import { Routes, Route, Navigate } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import { useSelector } from 'react-redux';
import ScrollToTop from './components/common/ScrollToTop';
import { Toaster } from '@/components/ui/sonner';

const HomePage = lazy(() => import('./pages/HomePage'));
const Privacy = lazy(() => import('./pages/Privacy'));
const Terms = lazy(() => import('./pages/Terms'));
const Dashboard = lazy(() => import('./pages/Dashboard/Dashboard'));
const SSERoom = lazy(() => import('./pages/Dashboard/Rooms/SSERoom'));

const LoadingFallback = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="h-1 w-48 bg-muted rounded-full overflow-hidden">
      <div className="h-full bg-primary animate-pulse rounded-full" style={{ width: '60%' }} />
    </div>
  </div>
);

function App() {
  const user = useSelector(state => state.auth?.user);

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route
          path="/"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <HomePage />
            </Suspense>
          }
        />
        <Route
          path="/privacy"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <Privacy />
            </Suspense>
          }
        />
        <Route
          path="/terms"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <Terms />
            </Suspense>
          }
        />
        <Route
          path="/rooms/:sessionId/sse"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <SSERoom />
            </Suspense>
          }
        />
        <Route
          path="/dashboard/*"
          element={
            user ? (
              <Suspense fallback={<LoadingFallback />}>
                <Dashboard />
              </Suspense>
            ) : (
              <Navigate to="/" />
            )
          }
        />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
      <Toaster />
    </>
  );
}

export default App;
